import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { Box, Drawer, Grid, TextField, Button, Divider, Typography } from '@mui/material';

// Custom Components
import { FilesTable } from '../';

// Utils
import messages from '../../static/messages';

// Services
import resourceServices from '../../services/resourceServices';

// Styles
import { button } from '../../static/theme-styles';

// External variables
const required_fields = ['description', 'price'];

const ScopeOfWorkDrawer = (props) => {
  const { currentItem, setCurrentItem, createItem, updateItem } = props;
  const [errors, setErrors] = useState({});

  // Action functions
  const resetErrors = () => {
    setErrors({});
    required_fields.forEach((el) =>
      setErrors((prevState) => ({
        ...prevState,
        [el]: false,
      })),
    );
  };

  // Handler functions
  const handleClose = () => props.onCloseDrawer(resetErrors);

  const handleChange = (e) => {
    const key = e.target.name;
    const val = e.target.value;

    setCurrentItem((prevState) => ({
      ...prevState,
      [key]: val,
      isEdited: true,
    }));
  };

  const handleValidate = () => {
    resetErrors();

    required_fields.forEach((field) => {
      if (currentItem[field] === '' || currentItem[field] === null) {
        setErrors((prevState) => ({
          ...prevState,
          [field]: true,
        }));
      } else {
        setErrors((prevState) => ({
          ...prevState,
          [field]: false,
        }));
      }
    });
  };

  // Async functions
  const onAddNewFile = async (e) => {
    const file = e.target.files[0];

    if (!currentItem.resources)
      setCurrentItem((prevState) => ({
        ...prevState,
        resources: [],
      }));

    try {
      const response = await resourceServices.upload(file, 'scope-of-work');

      if (response.status === 201) {
        setCurrentItem((prevState) => ({
          ...prevState,
          resources: [
            ...prevState.resources,
            {
              id: response.data.id,
            },
          ],
          isEdited: true,
        }));
      }
    } catch (error) {
      toast.error(messages.errors.error_try_again);
      console.log(error);
    }
  };

  // Hooks
  useEffect(() => {
    required_fields.forEach((el) =>
      setErrors((prevState) => ({
        ...prevState,
        [el]: false,
      })),
    );
  }, []);

  useEffect(() => {
    if (currentItem?.isEdited) {
      !Object.values(errors).includes(true) && (props.isNewItem ? createItem() : updateItem());
    }
  }, [errors]);

  return (
    <Drawer anchor="right" open={props.drawer} onClose={handleClose}>
      <Box>
        {props.currentItem && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box>
                <Typography variant="h4" gutterBottom>
                  {props.isNewItem ? 'Add New Item' : 'Update Item'}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                type="number"
                name="price"
                label="Price"
                defaultValue={currentItem.price}
                fullWidth
                onChange={handleChange}
                error={errors.price}
                helperText={errors.price && messages.errors.required_field}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                name="description"
                label="Description"
                multiline
                rows={4}
                defaultValue={currentItem.description}
                fullWidth
                onChange={handleChange}
                error={errors.description}
                helperText={errors.description && messages.errors.required_field}
              />
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Resources
              </Typography>

              {currentItem?.resources?.length > 0 && (
                <FilesTable {...{ files: currentItem?.resources, setCurrentItem }} />
              )}

              {!currentItem?.resources?.length && (
                <Typography variant="body2" sx={{ mb: 2 }}>
                  No Files
                </Typography>
              )}

              <Button variant="contained" component="label" sx={{ ...button('secondary'), mt: 2 }}>
                Upload
                <input hidden accept="image/*" multiple type="file" onChange={onAddNewFile} />
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                sx={{ ...button('primary', 'secondary'), mr: 3 }}
                disabled={!currentItem.isEdited}
                onClick={handleValidate}
              >
                {props.isNewItem ? 'Add New Item' : 'Update Item'}
              </Button>

              <Button variant="contained" onClick={handleClose} sx={button('secondary')}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Drawer>
  );
};

export default ScopeOfWorkDrawer;
